import React, { useState } from 'react';
import PageContainer from '../../components/common/PageContainer';
import PageSection from '../../components/common/PageSection';
import AdminNavigation from '../../components/admin/AdminNavigation';
import { useAuth } from '../../context/shared/AuthContext';
import apiService from '../../services/shared/apiService';

const GrantAccessPage = () => {
  const { user } = useAuth();
  const [targetUserId, setTargetUserId] = useState('');
  const [freeAccess, setFreeAccess] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleGrantAccess = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');

    // Check for admin role
    if (!user || user.role !== 'admin') {
      setError('You do not have permission to perform this action.');
      return;
    }

    if (!targetUserId) {
      setError('Please enter a User ID.');
      return;
    }

    try {
      const response: any = await apiService.post('/admin/set-free-access', {
        user_id: targetUserId,
        free_access: freeAccess,
      });
      setMessage(response.message);
    } catch (err: any) {
      const errorMessage = err.response?.data?.detail || err.message || 'An unexpected error occurred.';
      setError(errorMessage);
    }
  };

  // Check for admin role
  if (!user || user.role !== 'admin') {
    return (
      <PageContainer>
        <PageSection title="Access Denied" emoji="🚫">
          <p>You must be an authorized administrator to view this page.</p>
        </PageSection>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <AdminNavigation />
      <PageSection title="Grant User Free Access" emoji="🎟️">
        <form onSubmit={handleGrantAccess} className="space-y-4 max-w-md">
          <div>
            <label htmlFor="userId" className="block text-sm font-medium">
              Target User ID
            </label>
            <input
              type="text"
              id="userId"
              value={targetUserId}
              onChange={(e) => setTargetUserId(e.target.value)}
              className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-gray-900"
              placeholder="Enter the user's Firebase UID"
            />
          </div>
          <div className="flex items-center">
            <input
              id="freeAccess"
              name="freeAccess"
              type="checkbox"
              checked={freeAccess}
              onChange={(e) => setFreeAccess(e.target.checked)}
              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <label htmlFor="freeAccess" className="ml-2 block text-sm">
              Grant Free Access
            </label>
          </div>
          <button
            type="submit"
            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Update User Access
          </button>
        </form>
        {message && <p className="mt-4 text-green-600">{message}</p>}
        {error && <p className="mt-4 text-red-600">{error}</p>}
      </PageSection>
    </PageContainer>
  );
};

export default GrantAccessPage; 